<template>
  <view>
    <view style="height: 6vh;position:relative" bindtap="refresh">{{ pos }}</view>
    <cube-sticky pos="{{pos}}" wx:ref="sticky">
      <scroll-view
        scroll-y="{{ true }}"
        bindscroll="onScroll"
        style="height: 94vh;position:relative"
      >
        <view class="sticky-content">
          <view wx:for="{{ dataArr}}" wx:key="*this" class="content-item">内容1项 {{item}}</view>
        </view>

        <cube-sticky-ele eleKey="2">
          <view class="sticky-header">吸顶标题 2</view>
        </cube-sticky-ele>
        <view class="sticky-content">
          <view wx:for="{{[1,2,3,4,5]}}" wx:key="*this" class="content-item">内容2项 {{item}}</view>
        </view>

        <cube-sticky-ele eleKey="3">
          <view class="sticky-header">吸顶标题 3</view>
        </cube-sticky-ele>
        <view class="sticky-content">
          <view wx:for="{{[1,2,3,4,5,6,7,8,9,10]}}" wx:key="*this" class="content-item">内容项 {{item}}</view>
        </view>
      </scroll-view>
    </cube-sticky>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  options: {
    styleIsolation: 'shared',
  },
  data: {
    pos: 0,
    dataArr: [1, 2, 3, 4, 5],
  },
  methods: {
    refresh() {
      console.log('refresh')
      this.dataArr.push(6, 7)
      this.count = 1
    },
    onScroll(e) {
      this.pos = e.detail.scrollTop
      if (this.count) {
        this.count = 0
        this.$refs.sticky.refresh()
      }
    },
  },
})
</script>

<style lang="stylus">
.sticky-header
  height: 50px
  line-height: 50px
  padding: 0 15px
  background-color: #fc9153
  color: #fff
  font-size: 16px
  font-weight: bold

.sticky-content
  padding: 15px
  background-color: #f5f5f5

.content-item
  height: 120px
  line-height: 40px
  margin-bottom: 10px
  padding: 0 15px
  background-color: #fff
  border-radius: 4px
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "cube-sticky": "@mpxjs/mpx-cube-ui/src/components/sticky/index",
      "cube-sticky-ele": "@mpxjs/mpx-cube-ui/src/components/sticky/sticky-ele/index"
    }
  }
</script>